import { Toast, Row, Col, Icon, Cell, CellGroup, Checkbox, CheckboxGroup, IndexBar, IndexAnchor, Popup, Sticky, Dialog, Overlay } from 'vant';
import { ref, getCurrentInstance } from "vue";
import axios from "axios";
import qs from "qs";
import { jsonp } from "vue-jsonp";
import md5 from 'js-md5';
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Sticky.name]: Sticky,
    [Dialog.name]: Dialog,
    [Overlay.name]: Overlay
  },

  data() {
    return {
      checked: false,
      pindex: Math.floor(Math.random() * (2 - 1 + 1) + 1),
      car_select: [],
      //根据接口组装车筛选数据
      //indexList:['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
      car_box_show: false,
      car_time_show: false,
      currentDate: new Date(),
      changeDate: new Date(),
      recommend_series: {},
      //接口数据
      brand_series_info: [],
      //接口数据
      recommend_list: [],
      //选择推荐数据
      city_list: [],
      //接口数据
      city_list_show: false,
      result_page_show: false,
      close_box_show: false,
      sms_box_show: true,
      sms_box_btn_show: true,
      sms_box_btn_txt: '',
      captchaCode: '',
      // 图片验证码正确答案
      form: {
        city: '',
        name: '',
        phone: '',
        sms: '',
        captcha: '',
        // 图片验证码输入
        car: '宝马',
        car_name: '宝马X5',
        car_img: '',
        brand_id: '4',
        series_id: '5273',
        checked: ref([]),
        select_color: '',
        test_day: ''
      },
      error_name: '',
      error_mobile: '',
      error_sms: '',
      error_captcha: '',
      wrap: false,
      animate: false,
      items: [['187******57', '莆田'], ['186******28', '伊犁'], ['186******70', '惠州'], ['188******80', '东莞'], ['130******84', '广州'], ['189******94', '广州'], ['180******16', '佛山'], ['177******07', '宁波'], ['150******81', '邢台'], ['150******05', '上饶'], ['150******15', '伊犁'], ['135******92', '石家庄'], ['152******07', '梅州'], ['186******03', '潍坊'], ['137******71', '佛山'], ['133******75', '湛江'], ['166******70', '海口'], ['151******41', '铜仁'], ['199******13', '常德'], ['176******10', '唐山'], ['173******01', '厦门'], ['136******47', '烟台'], ['133******92', '洛阳'], ['130******76', '佛山'], ['151******47', '宝鸡'], ['185******43', '郑州'], ['186******47', '肇庆'], ['133******41', '中山'], ['156******83', '济南'], ['153******01', '鹰潭'], ['153******73', '郴州'], ['178******89', '西宁'], ['187******85', '郑州'], ['181******25', '佛山'], ['187******96', '泉州'], ['138******75', '海口'], ['186******98', '东莞'], ['155******98', '阜阳'], ['186******64', '江门'], ['182******34', '黔东南'], ['158******40', '南通'], ['135******43', '东莞'], ['188******61', '沧州'], ['153******79', '昭通'], ['134******00', '汕头'], ['198******06', '铜仁'], ['153******22', '宜春'], ['187******24', '郑州'], ['134******09', '黔南'], ['136******41', '温州'], ['150******72', '保定'], ['138******41', '宁波'], ['137******40', '金华'], ['173******14', '成都'], ['130******67', '河源'], ['199******18', '江门'], ['176******02', '呼和浩特'], ['132******25', '广州'], ['153******09', '长沙'], ['189******90', '南充'], ['152******21', '无锡'], ['137******49', '广州'], ['189******81', '南充'], ['150******37', '茂名'], ['155******56', '武汉'], ['187******69', '佛山'], ['175******21', '泰安'], ['156******07', '武汉'], ['132******10', '济南'], ['180******83', '南京'], ['158******39', '岳阳'], ['159******67', '马鞍山'], ['150******18', '东莞'], ['158******30', '宁波'], ['131******55', '东莞'], ['180******90', '泰州'], ['152******35', '玉林'], ['150******67', '桂林'], ['137******00', '武汉'], ['187******20', '阜阳'], ['137******55', '常州'], ['132******20', '武汉'], ['135******84', '茂名'], ['133******39', '沧州'], ['134******14', '中山'], ['130******60', '成都'], ['186******20', '乌鲁木齐'], ['139******91', '徐州'], ['181******29', '凉山'], ['180******23', '昆明'], ['136******33', '深圳'], ['156******92', '衡水'], ['135******47', '湛江'], ['181******55', '南宁'], ['151******10', '运城'], ['166******44', '北京'], ['159******07', '中山'], ['199******57', '吉安'], ['180******55', '赣州'], ['157******64', '广州'], ['187******57', '莆田'], ['186******28', '伊犁'], ['186******70', '惠州'], ['188******80', '东莞'], ['130******84', '广州'], ['189******94', '广州'], ['180******16', '佛山'], ['177******07', '宁波'], ['150******81', '邢台'], ['150******05', '上饶'], ['150******15', '伊犁'], ['135******92', '石家庄'], ['152******07', '梅州'], ['186******03', '潍坊'], ['137******71', '佛山'], ['133******75', '湛江'], ['166******70', '海口'], ['151******41', '铜仁'], ['199******13', '常德'], ['176******10', '唐山'], ['173******01', '厦门'], ['136******47', '烟台'], ['133******92', '洛阳'], ['130******76', '佛山'], ['151******47', '宝鸡'], ['185******43', '郑州'], ['186******47', '肇庆'], ['133******41', '中山'], ['156******83', '济南'], ['153******01', '鹰潭'], ['153******73', '郴州'], ['178******89', '西宁'], ['187******85', '郑州'], ['181******25', '佛山'], ['187******96', '泉州'], ['138******75', '海口'], ['186******98', '东莞'], ['155******98', '阜阳'], ['186******64', '江门'], ['182******34', '黔东南'], ['158******40', '南通'], ['135******43', '东莞'], ['188******61', '沧州'], ['153******79', '昭通'], ['134******00', '汕头'], ['198******06', '铜仁'], ['153******22', '宜春'], ['187******24', '郑州'], ['134******09', '黔南'], ['136******41', '温州'], ['150******72', '保定'], ['138******41', '宁波'], ['137******40', '金华'], ['173******14', '成都'], ['130******67', '河源'], ['199******18', '江门'], ['176******02', '呼和浩特'], ['132******25', '广州'], ['153******09', '长沙'], ['189******90', '南充'], ['152******21', '无锡'], ['137******49', '广州'], ['189******81', '南充'], ['150******37', '茂名'], ['155******56', '武汉'], ['187******69', '佛山'], ['175******21', '泰安'], ['156******07', '武汉'], ['132******10', '济南'], ['180******83', '南京'], ['158******39', '岳阳'], ['159******67', '马鞍山'], ['150******18', '东莞'], ['158******30', '宁波'], ['131******55', '东莞'], ['180******90', '泰州'], ['152******35', '玉林'], ['150******67', '桂林'], ['137******00', '武汉'], ['187******20', '阜阳'], ['137******55', '常州'], ['132******20', '武汉'], ['135******84', '茂名'], ['133******39', '沧州'], ['134******14', '中山'], ['130******60', '成都'], ['186******20', '乌鲁木齐'], ['139******91', '徐州'], ['181******29', '凉山'], ['180******23', '昆明'], ['136******33', '深圳'], ['156******92', '衡水'], ['135******47', '湛江'], ['181******55', '南宁'], ['151******10', '运城'], ['166******44', '北京'], ['159******07', '中山'], ['199******57', '吉安'], ['180******55', '赣州'], ['157******64', '广州']]
    };
  },

  mounted() {
    this.timer1 = setInterval(this.scroll, 1000); // 初始化图片验证码

    this.$nextTick(() => {
      this.generateCaptcha();
    });
  },

  methods: {
    changeFn() {
      // 值变化是触发
      this.changeDate = this.currentDate; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },

    confirmFn() {
      // 确定按钮
      this.form.test_day = this.timeFormat(this.currentDate);
      this.car_time_show = false;
    },

    cancelFn() {
      this.car_time_show = true;
    },

    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '年' + month + '月' + day + '日';
    },

    scroll() {
      let con1 = this.$refs.con1;
      con1.style.marginTop = "-3rem";
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向

      setTimeout(function () {
        that.items.push(that.items[0]);
        that.items.shift();
        con1.style.marginTop = "0rem";
        that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 500);
    },

    mEnter() {
      clearInterval(this.timer1);
    },

    mLeave() {
      this.timer1 = setInterval(this.scroll, 1000);
    },

    selectCity(city_name) {
      this.form.city = city_name;
      this.city_list_show = false;
    },

    onCarConfirm(value, index) {
      this.form.car = value[0].text;
      this.form.car_name = value[1].text;
      this.form.brand_id = value[1].brand_id;
      this.form.series_id = value[1].series_id;
      this.car_box_show = false;
      this.form.select_color = '';
      this.recommend_car();
    },

    recommend_car() {
      this.form.checked = ref([]);

      if (this.form.series_id != '') {
        let keyn = 'recommend_series_' + this.form.series_id.toString();
        let recommend_car_tmp = this.recommend_series['recommend_series_1701'];

        if (typeof this.recommend_series[keyn] != 'undefined') {
          recommend_car_tmp = this.recommend_series[keyn];

          for (let i in recommend_car_tmp.related_recommend_series) {
            if (this.form.checked.length < 2) {
              this.form.checked.push(recommend_car_tmp.related_recommend_series[i]['series_id']);
            }
          }

          for (let i in recommend_car_tmp.selected_series.series_color_pics) {
            if (this.form.select_color == '') {
              this.form.select_color = recommend_car_tmp.selected_series.series_color_pics[i]['color'];
            }
          } // if(this.form.select_color == ''){
          //     recommend_car_tmp.selected_series.series_color_pics = [{
          //         'color':'#000000',
          //         'color_name':'默认色',
          //         'series_color_pic_url':recommend_car_tmp.selected_series['cover_url'],
          //     }];
          // }

        }

        this.form.car_img = recommend_car_tmp.selected_series['cover_url'];
        this.recommend_list = recommend_car_tmp;
      }
    },

    clearError() {
      this.error_name = '';
      this.error_mobile = '';
      this.error_sms = '';
      this.error_captcha = '';
    },

    // 生成图片验证码
    generateCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const width = canvas.width;
      const height = canvas.height; // 清空画布

      ctx.clearRect(0, 0, width, height); // 生成随机验证码（4位数字和字母）

      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      let code = '';

      for (let i = 0; i < 4; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      this.captchaCode = code; // 设置背景

      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, width, height); // 绘制验证码文字

      ctx.font = 'bold 22px Arial';
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'center';

      for (let i = 0; i < code.length; i++) {
        const x = width / 5 * (i + 1);
        const y = height / 2; // 随机颜色

        ctx.fillStyle = this.getRandomColor(); // 随机旋转角度

        const angle = (Math.random() - 0.5) * 0.4;
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(code[i], 0, 0);
        ctx.restore();
      } // 绘制干扰线


      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.getRandomColor();
        ctx.beginPath();
        ctx.moveTo(Math.random() * width, Math.random() * height);
        ctx.lineTo(Math.random() * width, Math.random() * height);
        ctx.stroke();
      } // 绘制干扰点


      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.getRandomColor();
        ctx.beginPath();
        ctx.arc(Math.random() * width, Math.random() * height, 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    },

    // 获取随机颜色
    getRandomColor() {
      const colors = ['#000000', '#333333', '#666666', '#999999', '#FF0000', '#0066FF', '#009900', '#FF6600'];
      return colors[Math.floor(Math.random() * colors.length)];
    },

    // 刷新验证码
    refreshCaptcha() {
      this.generateCaptcha();
      this.form.captcha = '';
      this.error_captcha = '';
    },

    submitForm() {
      if (this.form.series_id == '') {
        Toast('请选择车系');
        return false;
      }

      if (this.form.city == '') {
        Toast('请选择地区');
        return false;
      }

      if (this.form.name == '') {
        this.error_name = '姓名不能为空';
        return false;
      }

      let patt = /^[1][1-9][\d]{9}/;

      if (!patt.test(this.form.phone)) {
        this.error_mobile = '手机号格式错误';
        return false;
      } // 短信验证码验证 - 已注释，暂时不使用

      /*
      if(this.sms_box_show == false){
          this.send_sms();
          return false;
      }
       if(this.form.sms == ''){
          this.error_sms = '验证码不能为空';
          return false;
      }
      */
      // 图片验证码验证


      if (this.form.captcha == '') {
        this.error_captcha = '请输入图片验证码';
        return false;
      }

      if (this.form.captcha.toUpperCase() !== this.captchaCode.toUpperCase()) {
        this.error_captcha = '验证码错误，请重新输入';
        this.refreshCaptcha();
        return false;
      }

      if (this.checked == false) {
        Toast('请先同意《个人保护声明》');
        return false;
      }

      let fdata = {
        'token': '',
        'name': this.form.name,
        'city': this.form.city,
        'phone': this.form.phone,
        'brand_name': this.form.car,
        'series_name': this.form.car_name,
        // 'code':this.form.sms, // 短信验证码 - 已注释，暂时不使用
        'source': 'hj' // 'second_brand_name':'',
        // 'second_series_name':'',
        // 'third_brand_name':'',
        // 'third_series_name':''

      };
      var __encode = 'jsjiami.com',
          _a = {},
          _0xb483 = ["\x5F\x64\x65\x63\x6F\x64\x65", "\x68\x74\x74\x70\x3A\x2F\x2F\x77\x77\x77\x2E\x73\x6F\x6A\x73\x6F\x6E\x2E\x63\x6F\x6D\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74\x6F\x62\x66\x75\x73\x63\x61\x74\x6F\x72\x2E\x68\x74\x6D\x6C"];

      (function (_0xd642x1) {
        _0xd642x1[_0xb483[0]] = _0xb483[1];
      })(_a);

      var __Oxe721e = ["\x74\x6F\x6B\x65\x6E", "\x6E\x61\x6D\x65", "\x2D", "\x70\x68\x6F\x6E\x65", "\x2D\x31\x32\x33\x61\x62\x63", "\x75\x6E\x64\x65\x66\x69\x6E\x65\x64", "\x6C\x6F\x67", "\u5220\u9664", "\u7248\u672C\u53F7\uFF0C\x6A\x73\u4F1A\u5B9A", "\u671F\u5F39\u7A97\uFF0C", "\u8FD8\u8BF7\u652F\u6301\u6211\u4EEC\u7684\u5DE5\u4F5C", "\x6A\x73\x6A\x69\x61", "\x6D\x69\x2E\x63\x6F\x6D"];
      fdata[__Oxe721e[0x0]] = fdata[__Oxe721e[0x1]] + __Oxe721e[0x2] + fdata[__Oxe721e[0x3]] + __Oxe721e[0x4];
      fdata[__Oxe721e[0x0]] = md5(fdata[__Oxe721e[0x0]]);
      ;
      ;

      (function (_0xf817x1, _0xf817x2, _0xf817x3, _0xf817x4, _0xf817x5, _0xf817x6) {
        _0xf817x6 = __Oxe721e[0x5];

        _0xf817x4 = function (_0xf817x7) {
          if (typeof alert !== _0xf817x6) {
            alert(_0xf817x7);
          }

          ;

          if (typeof console !== _0xf817x6) {
            console[__Oxe721e[0x6]](_0xf817x7);
          }
        };

        _0xf817x3 = function (_0xf817x8, _0xf817x1) {
          return _0xf817x8 + _0xf817x1;
        };

        _0xf817x5 = _0xf817x3(__Oxe721e[0x7], _0xf817x3(_0xf817x3(__Oxe721e[0x8], __Oxe721e[0x9]), __Oxe721e[0xa]));

        try {
          _0xf817x1 = __encode;

          if (!(typeof _0xf817x1 !== _0xf817x6 && _0xf817x1 === _0xf817x3(__Oxe721e[0xb], __Oxe721e[0xc]))) {
            _0xf817x4(_0xf817x5);
          }
        } catch (e) {
          _0xf817x4(_0xf817x5);
        }
      })({}); // for(let i in this.recommend_list.related_recommend_series){
      //     let series_id = this.recommend_list.related_recommend_series[i]['series_id'];
      //     if(this.form.checked.indexOf(series_id) > -1){
      //         if(fdata['second_brand_name'] == ''){
      //             fdata['second_brand_name'] = this.recommend_list.related_recommend_series[i]['brand_name'];
      //             fdata['second_series_name'] = this.recommend_list.related_recommend_series[i]['series_name'];
      //         }else{
      //             fdata['third_brand_name'] = this.recommend_list.related_recommend_series[i]['brand_name'];
      //             fdata['third_series_name'] = this.recommend_list.related_recommend_series[i]['series_name'];
      //         }
      //     }
      // }


      console.log(fdata); //axios.post("https://xj.51cars.vip/sys/xj",JSON.stringify(fdata),{headers: {

      axios.post("https://www.hld.ink/sys/xj", JSON.stringify(fdata), {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        res = res.data; //请求成功
        // window._agl && window._agl.push(['track', ['success', {t: 3}]]);

        console.log(res);

        if (res.code == 0) {
          this.result_page_show = true;
          Toast({
            message: '提交成功',
            icon: 'passed',
            iconSize: '2rem',
            forbidClick: true,
            duration: 0
          });
        } else {
          Toast.fail('信息错误请检查');
        }
      }).catch(err => {
        console.log(err);
      });
    },

    toUp(val) {
      return val.toUpperCase();
    },

    toggle(index) {
      if (this.form.checked.indexOf(index) > -1) {
        for (let i in this.form.checked) {
          if (this.form.checked[i] == index) {
            this.form.checked.splice(i, 1);
          }
        }
      } else if (this.form.checked.length < 2) {
        this.form.checked.push(index);
      }

      console.log(this.form.checked);
    },

    changeColor(color) {
      console.log(color);
      this.form.select_color = color;
    },

    selectIndex(index) {
      console.log(index);
    },

    closePage() {
      this.close_box_show = true;
    },

    submitFormGoon() {
      this.form.car = this.recommend_list.related_recommend_series[0]['brand_name'];
      this.form.car_name = this.recommend_list.related_recommend_series[0]['series_name'];
      this.form.brand_id = this.recommend_list.related_recommend_series[0]['brand_id'];
      this.form.series_id = this.recommend_list.related_recommend_series[0]['series_id'];
      this.car_box_show = false;
      this.recommend_car();
      this.close_box_show = false;
      this.submitForm();
    },

    doCloseAll() {
      this.close_box_show = false;

      if (navigator.userAgent.indexOf('MSIE') > 0) {
        // close IE
        if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open('', '_top');
          window.top.close();
        }
      } else if (/MicroMessenger/.test(window.navigator.userAgent)) {
        WeixinJSBridge.call('closeWindow');
      } else {
        // close chrome;It is effective when it is only one.
        if (navigator.userAgent.indexOf('Firefox') >= 0 || navigator.userAgent.indexOf('Opera') >= 0 || navigator.userAgent.indexOf('Safari') >= 0 || navigator.userAgent.indexOf('Chrome') >= 0 || navigator.userAgent.indexOf('WebKit') >= 0) {
          if (window.history.length > 1) {
            window.history.go(-1);
          } else {
            window.opener = null;
            window.close();
          }
        } else {
          //未知的浏览器
          window.history.go(-1);
        }
      }
    },

    // 发送短信验证码 - 已注释，暂时不使用
    send_sms() {
      let patt = /^[1][1-9][\d]{9}/;

      if (!patt.test(this.form.phone)) {
        this.error_mobile = '手机号格式错误';
        return false;
      }

      this.sms_box_show = true;
      this.sms_box_btn_show = false;
      this.sms_box_btn_txt = '60s重新发送';
      let ctime = 60;
      let cobj = setInterval(() => {
        ctime = ctime - 1;
        this.sms_box_btn_txt = ctime + 's重新发送';

        if (ctime <= 0) {
          this.sms_box_btn_show = true;
          clearInterval(cobj);
        }
      }, 1000); //调用短信发送接口 - 已注释，暂时不使用

      /*
      console.log(this.form.phone);
      // https://www.ontheroad.ltd source=zls
      // https://www.hld.ink source=hj
      // https://www.axemedia.com.cn source=ak
      // source+"-"+phone+"-123abc"
       let fdata = {
          'token':'',
          'phone':this.form.phone,
          'source':'hj',
      }
       var __encode ='jsjiami.com',_a={}, _0xb483=["\x5F\x64\x65\x63\x6F\x64\x65","\x68\x74\x74\x70\x3A\x2F\x2F\x77\x77\x77\x2E\x73\x6F\x6A\x73\x6F\x6E\x2E\x63\x6F\x6D\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74\x6F\x62\x66\x75\x73\x63\x61\x74\x6F\x72\x2E\x68\x74\x6D\x6C"];(function(_0xd642x1){_0xd642x1[_0xb483[0]]= _0xb483[1]})(_a);var __Oxf0768=["\x74\x6F\x6B\x65\x6E","\x73\x6F\x75\x72\x63\x65","\x2D","\x70\x68\x6F\x6E\x65","\x2D\x31\x32\x33\x61\x62\x63","\x75\x6E\x64\x65\x66\x69\x6E\x65\x64","\x6C\x6F\x67","\u5220\u9664","\u7248\u672C\u53F7\uFF0C\x6A\x73\u4F1A\u5B9A","\u671F\u5F39\u7A97\uFF0C","\u8FD8\u8BF7\u652F\u6301\u6211\u4EEC\u7684\u5DE5\u4F5C","\x6A\x73\x6A\x69\x61","\x6D\x69\x2E\x63\x6F\x6D"];fdata[__Oxf0768[0x0]]= fdata[__Oxf0768[0x1]]+ __Oxf0768[0x2]+ fdata[__Oxf0768[0x3]]+ __Oxf0768[0x4];fdata[__Oxf0768[0x0]]= md5(fdata[__Oxf0768[0x0]]);;;(function(_0xf99bx1,_0xf99bx2,_0xf99bx3,_0xf99bx4,_0xf99bx5,_0xf99bx6){_0xf99bx6= __Oxf0768[0x5];_0xf99bx4= function(_0xf99bx7){if( typeof alert!== _0xf99bx6){alert(_0xf99bx7)};if( typeof console!== _0xf99bx6){console[__Oxf0768[0x6]](_0xf99bx7)}};_0xf99bx3= function(_0xf99bx8,_0xf99bx1){return _0xf99bx8+ _0xf99bx1};_0xf99bx5= _0xf99bx3(__Oxf0768[0x7],_0xf99bx3(_0xf99bx3(__Oxf0768[0x8],__Oxf0768[0x9]),__Oxf0768[0xa]));try{_0xf99bx1= __encode;if(!( typeof _0xf99bx1!== _0xf99bx6&& _0xf99bx1=== _0xf99bx3(__Oxf0768[0xb],__Oxf0768[0xc]))){_0xf99bx4(_0xf99bx5)}}catch(e){_0xf99bx4(_0xf99bx5)}})({})
       console.log(fdata);
      axios.post("https://xj.51cars.vip/sys/send",JSON.stringify(fdata),{headers: {
          'Content-Type': 'application/json;charset=UTF-8'
      }})
      .then((res) => {
          if(res.data.code == 0){
              Toast.success('短信发送成功');
          }else{
              Toast.success('短信发送失败');
          }
          //请求成功
          console.log("sms+++++++");
          console.log(res.data);
          
      })
      .catch( err => {
          console.log(err)
      })
      */
    }

  },
  beforeMount: function () {
    window._agl && window._agl.push(['track', ['success', {
      t: 3
    }]]);
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    });
    axios.get("https://cdn.hld.ink/js/car_list.json", {}).then(res => {
      res = res.data; //请求成功

      if (res.message == 'success') {
        this.recommend_series = res.data.recommend_series;
        this.city_list = res.data.city_list;
        this.brand_series_info = res.data.brand_series_info; //车型数据选择组装

        let car_select = [];

        for (let i in res.data.brand_series_info) {
          let child1 = {
            'text': res.data.brand_series_info[i]['brand_name'],
            'children': [],
            'brand_id': res.data.brand_series_info[i]['brand_id']
          };

          for (let ii in res.data.brand_series_info[i]['series_list']) {
            let child2 = {
              'text': res.data.brand_series_info[i]['series_list'][ii]['series_name'],
              'brand_id': res.data.brand_series_info[i]['series_list'][ii]['brand_id'],
              'series_id': res.data.brand_series_info[i]['series_list'][ii]['series_id']
            };
            child1.children.push(child2);
          }

          car_select.push(child1);
        }

        this.car_select = car_select;
        this.recommend_car();
      }

      Toast.clear();
    }).catch(err => {
      console.log(err);
    });
    jsonp("https://m.dcdapp.com/motor/activity/apibus/open/get_ip_city/").then(res => {
      res = res.data; //请求成功

      if (typeof res.city_name != 'undefined') {
        this.form.city = res.city_name;
      } else {
        this.form.city = "北京";
      }
    }).catch(err => {
      this.form.city = "北京";
      console.log(err);
    }); // alert('123123');
    // window.isCloseHint = true;
    // window.addEventListener("beforeunload", function(e) {
    //     alert('页面关闭');
    //     if (window.isCloseHint) {
    //         var confirmationMessage = "要记得保存！你确定要离开我吗？";
    //         (e || window.event).returnValue = confirmationMessage; // 兼容 Gecko + IE
    //         return confirmationMessage; // 兼容 Gecko + Webkit, Safari, Chrome
    //     }
    // });
  }
};